import React from 'react';

import { TEntryDataType } from '@/types';
import * as Styled from './styled';
import * as Icon from '@/ui/Icon';

type BadgeProps = React.HTMLProps<HTMLSpanElement> & {
  children?: React.ReactNode;
  theme?: any;
  variant?: TEntryDataType;
  icon?: boolean;
  iconOnly?: boolean;
  title?: string;
  small?: boolean;
};

const DataTypeIcon = ({ variant, size }: { variant?: TEntryDataType; size: string }) => {
  switch (variant) {
    case 'text':
      return <Icon.Text size={size} />;
    case 'image':
      return <Icon.Image size={size} />;
    case 'video':
      return <Icon.Video size={size} />;
    case 'audio':
      return <Icon.Audio size={size} />;
    case 'tabular':
      return <Icon.Table size={size} />;
    case 'binary':
      return <Icon.Binary size={size} />;
    case 'directory':
      return <Icon.FolderOpen size={size} />;
    case 'application':
      return <Icon.File size={size} />;
    default:
      return <Icon.QuestionCircle size={size} />;
  }
};

const Badge: React.FC<BadgeProps> = ({
  children = 'Unknown',
  variant,
  theme = {},
  icon = true,
  title,
  small,
  iconOnly,
  ...rest
}) => {
  return (
    <Styled.Badge $variant={variant} title={title} $small={!!small} {...rest}>
      {icon && <DataTypeIcon variant={variant} size={small ? '10px' : '12px'} />}
      {!iconOnly && <span className="truncate">{children}</span>}
    </Styled.Badge>
  );
};

export default Badge;
